var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInvestInYourPension = function SvgInvestInYourPension(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 216 216"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "invest-in-your-pension_svg__a",
    width: 216,
    height: 216,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 216,
    height: 216,
    fill: "#FEF2EC",
    rx: 108
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#invest-in-your-pension_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEF2EC",
    d: "M0 0h216v203H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#089263",
    d: "m82.347 145.822 65.515-64.846 64.311 64.974z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#089263",
    d: "m30.96 145.939 52.081-51.64 51.214 51.651z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.812,
    cy: 64.266,
    r: 19.28,
    fill: "#F6BC2D"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9EC6D9",
    d: "M-5 145h231l-44.688 72.228L36.938 219z"
  }))));
};
export { SvgInvestInYourPension as ReactComponent };
export default __webpack_public_path__ + "images/invest-in-your-pension.svg";